import script from "./PortfolioUserShareChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioUserShareChart.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioUserShareChart.vue?vue&type=style&index=0&id=68034772&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68034772"]])

export default __exports__